function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.494 9.35a1.09 1.09 0 00-.517-.935L11 5.5 6.022 8.415a1.095 1.095 0 00-.522.935v5.5c0 .605.495 1.1 1.1 1.1h8.8c.605 0 1.1-.495 1.1-1.1l-.006-5.5zM11 12.1L6.457 9.262 11 6.6l4.543 2.662L11 12.1z",
  fill: "#fff"
});

function SvgDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _ref);
}

export default SvgDraft;